const INDEX_DB_NAME = 'hqzen_db';
const INDEXED_DB_VERSION = 1;
const COLLECTION_NAME = 'hqzen.com';

const idb = {
    
    db: null,

    async init() {
        this.db = await new Promise((resolve, reject) => {

            let request = window.indexedDB.open(INDEX_DB_NAME, INDEXED_DB_VERSION);
            
            request.onerror = e => {
                console.error('Error opening db', e);
                reject('Error');
            };
        
            request.onsuccess = e => {
                resolve(e.target.result);
            };
            
            // Incase the table structure changes
            // Increment the Db version number and re-run all createObjectStore(s)
            request.onupgradeneeded = e => {
                let db = e.target.result;
                // Technically these are your tables (collections)
                // Add more tables here
                let objectStore = db.createObjectStore(COLLECTION_NAME, { autoIncrement: true, keyPath:'data_key' });
                objectStore.createIndex("data_key", "data_key", { unique: true });
            };
        });
    },

    reset(db = this.db) {
        return new Promise(async (resolve, reject) => {
            if (!db) throw new Error('Sorry, no database initiated')
            
            try {
                // open a read/write db transaction, ready for clearing the data
                const transaction = db.transaction([COLLECTION_NAME], "readwrite");
                
                // report on the success of the transaction completing, when everything is done
                transaction.oncomplete = function(event) {
                    console.log('Opened DB for operations');
                };

                // create an object store on the transaction
                const objectStore = transaction.objectStore(COLLECTION_NAME);
            
                // Make a request to clear all the data out of the object store
                const objectStoreRequest = objectStore.clear();
            
                objectStoreRequest.onsuccess = function(event) {
                    // report the success of our request
                    resolve('Request successful.')
                };

                objectStoreRequest.onerror = function(e) {
                    reject('Error found: ', e)
                }
            
                transaction.onerror = function(e) {
                    reject('Sorry IDB clear failed with error', transaction.error)
                };
            } catch(e) {
                reject('Something went wrong' ,e)
            }
        })
    },

    collection(dataKeyPath, db = this.db) {
        return {
            add: (DATA) => {
                return new Promise((resolve, reject) => {
                    if (!DATA || !dataKeyPath) reject('null data passed or invalid collection key');
                    let trans = db.transaction([COLLECTION_NAME], 'readwrite');
                
                    let store = trans.objectStore(COLLECTION_NAME);
                    const idbDATA = {
                        ...DATA,
                        data_key: dataKeyPath,
                    };

                    store.add(idbDATA)

                    trans.oncomplete = e => {
                        resolve(idbDATA);
                    };
        
                    trans.onerror = e => {
                        reject(new Error('Sorry, data key already exists. Please run update instead'));
                    };
                
                });
            },
            get: () => {
                return new Promise((resolve, reject) => {
                    let trans = this.db.transaction([COLLECTION_NAME],'readonly');
                    let objectStore = trans.objectStore(COLLECTION_NAME);
                    let document = null;
                    const PATH = dataKeyPath;
            
                    let index = objectStore.index('data_key');
            
                    index.openCursor().onerror = function(e) {
                        reject(new Error(e));
                    }
                    
                    index.openCursor().onsuccess = function(event) {
                        var cursor = event.target.result;
                        if (cursor) {
                            if (cursor.value.data_key == PATH) {
                                document = cursor.value;
                            }
                            cursor.continue();
                        }
                    }

                    trans.oncomplete = () => {
                        if (document) {
                            resolve(document);
                        } else {
                            reject('Sorry, object not found');
                        }
                    };
                });
            },
            docs: () => {
                return new Promise((resolve, reject) => {
                    let trans = this.db.transaction([COLLECTION_NAME],'readonly');
                    
                    let store = trans.objectStore(COLLECTION_NAME);
                    let docs = [];
                    
                    store.openCursor().onsuccess = e => {
                        let cursor = e.target.result;
                        if (cursor) {
                            docs.push(cursor.value);
                            cursor.continue();
                        }
                    };
        
                    trans.onerror = e => {
                        reject(new Error(e));
                    };

                    trans.oncomplete = e => {
                        resolve(docs);
                    };
            
                });
            },
            update: (DATA) => {
                return new Promise((resolve, reject) => {
                    const transaction = db.transaction([COLLECTION_NAME], 'readwrite');
                    const PATH = dataKeyPath;
                    
                    transaction.onerror = function(e) {
                        reject(new Error(e));
                    }
                    const objectStore = transaction.objectStore(COLLECTION_NAME);
        
                    objectStore.onerror = function(e) {
                        reject(new Error(e));
                    }
        
                    objectStore.openCursor().onsuccess = function(event) {
                        const cursor = event.target.result;
                        if (cursor) {
                          if (cursor.value.data_key === PATH) {
                            const request = cursor.update(
                                { ...DATA, data_key: dataKeyPath }
                            );
                            request.onsuccess = function() {
                                resolve(DATA);
                            };
        
                            request.onerror = function(e) {
                                reject(new Error(e));
                            }
                          }
                          cursor.continue();
                        }
                      };
                });
            },
            delete: () => {
                return new Promise((resolve, reject) => {
                    if (!dataKeyPath) reject('please provide a collection key');
                    const transaction = this.db.transaction([COLLECTION_NAME], 'readwrite');
                    const objectStore = transaction.objectStore(COLLECTION_NAME);
                    const PATH = dataKeyPath;
        
                    var objectStoreRequest = objectStore.delete(PATH);
                    objectStoreRequest.onsuccess = function(event) {
                        resolve('Sucess');
                      };
        
                      objectStoreRequest.onerror = function(e) {
                        reject(new Error(e));
                      }
                });
            },
            dropCollections: (collections) => {
                if (!(collections instanceof Array)) return Promise.reject('Please provide an array');
                collections.forEach(col => {
                    dropCollection(col)
                })

                const dropCollection = (col) => {
                    this.collection(col).delete();
                };
            }
        }
    },

    docs() {
        return new Promise((resolve, reject) => {
            let trans = this.db.transaction([COLLECTION_NAME],'readonly');
            trans.oncomplete = e => {
                resolve(docs);
            };
            
            let store = trans.objectStore(COLLECTION_NAME);
            let docs = [];
            
            store.openCursor().onsuccess = e => {
                let results = e.target.result;
                if (results) {
                    docs.push(results.value);
                    results.continue();
                }
            };

            trans.onerror = e => {
                reject('Error');
                throw new Error(e);
            };
    
        });
    },

    add(doc) {
        return new Promise((resolve, reject) => {

            let trans = this.db.transaction([COLLECTION_NAME], 'readwrite');
            trans.oncomplete = e => {
                resolve();
            };

            trans.onerror = e => {
                reject('Error');
            };
        
            let store = trans.objectStore(COLLECTION_NAME);
            store.add(doc);
        
        });
    },

    get(key) {
        return new Promise((resolve, reject) => {
            let trans = this.db.transaction([COLLECTION_NAME],'readonly');
        let objectStore = trans.objectStore(COLLECTION_NAME);

        let index = objectStore.index('data_key');

        index.openCursor().onerror = function(e) {
            reject('Error', e);
            throw new Error(e);
        }

        index.openCursor().onsuccess = function(event) {
            var cursor = event.target.result;
            if (cursor) {
                if (cursor.value.data_key == key) {
                    resolve(cursor.value);
                }
                cursor.continue();
            }
        }
        });
    },

    update(updatedDoc) {
        return new Promise((resolve, reject) => {
            const transaction = this.db.transaction([COLLECTION_NAME], 'readwrite');
            
            transaction.onerror = function(e) {
                reject('Error');
                throw new Error(e);
            }
            const objectStore = transaction.objectStore(COLLECTION_NAME);

            objectStore.onerror = function(e) {
                reject('Error');
                throw new Error(e);
            }

            objectStore.openCursor().onsuccess = function(event) {
                const cursor = event.target.result;
                if (cursor) {
                  if (cursor.value.data_key === updatedDoc.data_key) {
                    
                    const request = cursor.update({
                        ...updatedDoc
                    });
                    request.onsuccess = function() {
                      resolve();
                    };

                    request.onerror = function(e) {
                        reject('Error');
                        throw new Error(e);
                    }
                  }
                  cursor.continue();
                }
              };
        });
    },

    delete(DataKey) {
        return new Promise((resolve, reject) => {
            const transaction = this.db.transaction([COLLECTION_NAME], 'readwrite');
            const objectStore = transaction.objectStore(COLLECTION_NAME);

            var objectStoreRequest = objectStore.delete(DataKey);
            objectStoreRequest.onsuccess = function(event) {
                resolve();
              };

              objectStoreRequest.onerror = function(e) {
                reject();
                throw new Error(e);
              }
        });
    }

}

export default idb;